/**
 * Public store listing URLs for the Flass native app.
 *
 * Hardcoded rather than env-driven: these are public marketing URLs baked
 * into a static bundle anyone can read, so env indirection would buy nothing.
 * Consumers should treat an empty string as "not available yet" and render
 * nothing rather than a dead link.
 */
export const IOS_APP_STORE_URL =
	'https://apps.apple.com/app/flass-campus-chat/id6804436837';

export const ANDROID_PLAY_STORE_URL =
	'https://play.google.com/store/apps/details?id=com.flass.mobile';
